document.addEventListener('DOMContentLoaded', function () {

  /* ── HAMBURGER ── */
  var btn    = document.getElementById('hamburger');
  var drawer = document.getElementById('nav-drawer');
  if (btn && drawer) {
    btn.addEventListener('click', function () {
      var open = drawer.style.display === 'flex';
      drawer.style.display = open ? 'none' : 'flex';
      btn.setAttribute('aria-expanded', String(!open));
      var spans = btn.querySelectorAll('span');
      if (!open) {
        spans[0].style.transform = 'translateY(7px) rotate(45deg)';
        spans[1].style.opacity   = '0';
        spans[2].style.transform = 'translateY(-7px) rotate(-45deg)';
      } else {
        spans.forEach(function(s){ s.style.transform = ''; s.style.opacity = ''; });
      }
    });
    document.addEventListener('click', function (e) {
      if (!btn.contains(e.target) && !drawer.contains(e.target)) {
        drawer.style.display = 'none';
        btn.setAttribute('aria-expanded', 'false');
        btn.querySelectorAll('span').forEach(function(s){ s.style.transform = ''; s.style.opacity = ''; });
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.style.display === 'flex') {
        drawer.style.display = 'none';
        btn.setAttribute('aria-expanded', 'false');
        btn.focus();
      }
    });
  }

  /* ── SCROLL REVEAL ── */
  var els = document.querySelectorAll('.reveal');
  if (window.IntersectionObserver) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    els.forEach(function (el) { obs.observe(el); });
  } else {
    els.forEach(function (el) { el.classList.add('in'); });
  }

  /* ── FILTER TABS ── */
  document.querySelectorAll('.f-tab').forEach(function (tab) {
    tab.addEventListener('click', function () {
      document.querySelectorAll('.f-tab').forEach(function (t) { t.classList.remove('on'); });
      this.classList.add('on');
      var filter = this.getAttribute('data-filter');
      document.querySelectorAll('#products-grid .prod').forEach(function (card) {
        card.style.display = (filter === 'all' || card.getAttribute('data-type') === filter) ? '' : 'none';
      });
    });
  });

  /* ── WISHLIST HEARTS ── */
  var wl = [];
  try { wl = JSON.parse(localStorage.getItem('fs_wl') || '[]'); } catch (e) {}
  document.querySelectorAll('.prod-heart').forEach(function (btn) {
    var id = btn.getAttribute('data-id');
    if (id && wl.indexOf(id) !== -1) { btn.textContent = '♥'; btn.style.color = 'var(--rose)'; }
    btn.addEventListener('click', function (e) {
      e.stopPropagation(); e.preventDefault();
      var saved = this.textContent === '♥';
      this.textContent = saved ? '♡' : '♥';
      this.style.color = saved ? '' : 'var(--rose)';
      if (id) {
        wl = saved ? wl.filter(function (i) { return i !== id; }) : (wl.indexOf(id) === -1 ? wl.concat([id]) : wl);
        try { localStorage.setItem('fs_wl', JSON.stringify(wl)); } catch (e) {}
      }
    });
  });

  /* ── QUICK ADD TO CART (collection / homepage grids) ── */
  function updateCartBadge(count) {
    var badge = document.getElementById('cart-count-badge');
    if (badge) {
      badge.textContent = count;
      badge.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  document.querySelectorAll('.prod-atc').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation(); e.preventDefault();
      var vid = this.getAttribute('data-vid');
      if (!vid) return;
      var orig = this.textContent;
      this.textContent = 'Adding…';
      this.disabled = true;
      var self = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: parseInt(vid, 10), quantity: 1 })
      })
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (d.status && d.status !== 200) throw new Error(d.description || 'Error');
        self.textContent = '✓ Added!';
        self.style.background = 'var(--sage)';
        return fetch('/cart.js', { headers: { Accept: 'application/json' } });
      })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadge(cart.item_count);
        setTimeout(function () {
          self.textContent = orig;
          self.style.background = '';
          self.disabled = false;
        }, 1800);
      })
      .catch(function () {
        self.textContent = 'View →';
        self.style.background = 'var(--rose)';
        self.disabled = false;
      });
    });
  });

});
